// Obfuscated mailto: reveal on click
// Email is XOR-encoded in data attributes to prevent bot scraping

function decode(encoded) {
  const bytes = atob(encoded)
  let result = ""
  for (let i = 0; i < bytes.length; i++) {
    result += String.fromCharCode(bytes.charCodeAt(i) ^ 0x5a)
  }
  return result
}

function revealEmail(el) {
  const user = decode(el.dataset.mu)
  const domain = decode(el.dataset.md)
  const email = `${user}@${domain}`
  const subject = el.dataset.ms ? decode(el.dataset.ms) : null

  let href = `mailto:${email}`
  if (subject) href += `?subject=${encodeURIComponent(subject)}`

  el.href = href
  el.removeAttribute("data-mailto")
  el.removeAttribute("data-mu")
  el.removeAttribute("data-md")
  if (el.dataset.ms) el.removeAttribute("data-ms")
  el.removeAttribute("role")
  el.removeAttribute("tabindex")

  // Replace placeholder text if present
  const placeholder = el.querySelector(".mailto-placeholder")
  if (placeholder) {
    placeholder.textContent = email
    placeholder.classList.remove("mailto-placeholder")
  }

  window.location.href = href
}

document.addEventListener("click", (e) => {
  const link = e.target.closest("a[data-mailto]")
  if (!link) return
  e.preventDefault()
  revealEmail(link)
})

document.addEventListener("keydown", (e) => {
  if (e.key !== "Enter" && e.key !== " ") return
  const link = e.target.closest("a[data-mailto]")
  if (!link) return
  e.preventDefault()
  revealEmail(link)
})
